const { default: formatMoney } = require("./formatMoney");
const { default: formatNumber } = require("./formatNumber");

const formatMetricValue = (metric, value) => {
  if (value === null) {
    return "-";
  }

  if (value && typeof value === "string") {
    value = parseFloat(value);
  }

  switch (metric) {
    case "cost":
      return formatMoney(value);
    case "conversion":
    case "conversions":
      return formatNumber(value);
    case "cpc":
      return formatMoney(value);
    case "avg_cpc":
      return formatMoney(value);
    case "ctr":
      return formatNumber(value) + "%";
    default:
      return formatNumber(value);
  }
};

export default formatMetricValue;
